function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  fill: "white",
  stroke: "#BF3333"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.5 12.205L28.795 11.5L26 14.295L23.205 11.5L22.5 12.205L25.295 15L22.5 17.795L23.205 18.5L26 15.705L28.795 18.5L29.5 17.795L26.705 15L29.5 12.205Z",
  fill: "#BF3333"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1335 25.6667L17.0668 19.6C17.6668 18.0667 17.3335 16.2667 16.0668 15C14.7335 13.6667 12.7335 13.4 11.1335 14.1334L14.0001 17L12.0001 19L9.06679 16.1334C8.26679 17.7334 8.60012 19.7334 9.93346 21.0667C11.2001 22.3334 13.0001 22.6667 14.5335 22.0667L20.6001 28.1334C20.8668 28.4 21.2668 28.4 21.5335 28.1334L23.0668 26.6C23.4001 26.3334 23.4001 25.8667 23.1335 25.6667Z",
  fill: "#BF3333"
});

var SvgWrenchMinus = function SvgWrenchMinus(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/wrench-minus.db4e492c.svg";
export { SvgWrenchMinus as ReactComponent };